import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import SaleFooter from '../SaleFooter/SaleFooter';
import { goToPage, reportAnalytics, setPremiumPackageChanged, setProductVasChanged, setProductVasPopupChanged, setVasPopupChanged, displayProductVas, selectProductVas } from '../saleBlockSlice';
import ProductVases from '../ProductVases/ProductVases';
import PremiumPackages from '../PremiumPackages/premiumPackages';

const ExtraPage = (props) => {

  let saleType = props.saleType;
  let flowType = props.flowType;

  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    switch (saleType) {
      case 'tv':
        props.reportAnalytics({
          eventCategory: 'tv_newsale_process',
          eventAction: flowType == 'existsCustomer' ? 'visibility_8' : 'visibility_16',
          eventLabel: eventLabel,
        });
        break;
      case 'app':
        props.reportAnalytics({ eventCategory: 'app_newsale_process', eventAction: 'visibility_27', eventLabel: eventLabel });
        break;
    }
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = 'אפשר להתקדם';
  let currentPageFunction = handleExtraProductsPageContinue;
  let totalPrice = props.totalPrice;
  let totalPriceOneTime = props.totalPriceOneTime;
  let priceText = 'לחודש';
  let formid = 'sale';

  let title = '';
  switch (saleType) {
    case 'tv':
    case 'app':
      title = 'מה עם חבילות ערוצי פרימיום שישדרגו לכם את הצפייה?';
      break;
    case 'cellular':
      title = 'מה עם קצת תוספות?';
      break;
  }

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'> {title} </h1>

      {saleType == 'cellular' && (
        <h2 className='sale-title-small'>אפשר להמשיך גם בלי תוספות</h2>
      )}
    </div>
  );

  let currentPageView = null;

  if (saleType == 'cellular') {
    const lastProduct = props.productsInfo.selectedProducts[props.productsInfo.selectedProducts.length - 1];
    let filteredVasList = lastProduct.vasList?.filter((x) => !x.isVirtualSoc);
    currentPageView = <ProductVases vasList={filteredVasList} onProductVasChange={onProductVasChange} onProductVasPopupChange={onProductVasPopupChange} onDisplayProductVas={props.displayProductVas} onSelectProductVas={props.selectProductVas} />;
  }
  else {
    currentPageView = <PremiumPackages premiumPackages={props.premiumPackages} onPremiumPackageChange={onPremiumPackageChange} onPopupChange={onPopupChange} />;
  }

  //-----------------------------------------------
  function onPremiumPackageChange(id, vasId, isSelected) {
    props.setPremiumPackageChanged({ id: id, vasId: vasId, isSelected: isSelected });
  }
  function onPopupChange(id, isOpenPopUp) {
    props.setVasPopupChanged({ id: id, isOpenPopUp: isOpenPopUp });
  }
  //-----------------------------------------------
  function onProductVasChange(id, isSelected) {
    props.setProductVasChanged({ id: id, isSelected: isSelected });
  }
  function onProductVasPopupChange(id, isOpenPopUp) {
    props.setProductVasPopupChanged({ id: id, isOpenPopUp: isOpenPopUp });
  }
  //-----------------------------------------------

  function handleExtraProductsPageContinue() {

    switch (saleType) {
      case 'tv':
        if (flowType == 'existsCustomer') {
          props.goToPage({ page: 'userAddressPage', percent: 44 });
        } else {
          props.goToPage({ page: 'addressFormPage', percent: 27 });
        }
        break;
      case 'app':
        props.goToPage({ page: 'otpVerifyPhone', percent: 28 });
        break;
      case 'cellular':
        if (flowType == 'existsCustomer') {
          props.goToPage({ page: 'newNumberPage', percent: 28 });
        } else {
          props.goToPage({ page: 'newNumberPage', percent: 20 });
        }
        break;
    }

    const eventLabel = props.productsInfo.selectedProducts[0]?.name;
    switch (saleType) {
      case 'tv':
        props.reportAnalytics({ eventCategory: 'tv_newsale_process', eventAction: flowType == 'existsCustomer' ? 'click_10' : 'click_23', eventLabel: eventLabel });
        break;
      case 'app':
        props.reportAnalytics({ eventCategory: 'app_newsale_process', eventAction: 'click_38', eventLabel: eventLabel });
        break;
    }
  }

  function handleContinueWithoutExtra() {
    if (flowType == 'existsCustomer') {
      props.goToPage({ page: 'newNumberPage', percent: 28 });
    } else {
      props.goToPage({ page: 'newNumberPage', percent: 20 });
    }
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content width-664'>
        {currentPageView}
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} totalPriceOneTime={totalPriceOneTime} priceText={priceText} formid={formid} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    totalPrice: state.saleBlock.totalPrice,
    totalPriceOneTime: state.saleBlock.totalPriceOneTime,
    premiumPackages: state.saleBlock.premiumPackages,
    selectedVasList: state.saleBlock.selectedVasList,
    productsInfo: state.saleBlock.productsInfo,
    //other states
  };
};

const mapDispatchToProps = {
  goToPage,
  reportAnalytics,
  setPremiumPackageChanged,
  setProductVasChanged,
  setProductVasPopupChanged,
  setVasPopupChanged,
  displayProductVas,
  selectProductVas
};

export default connect(mapStateToProps, mapDispatchToProps)(ExtraPage);
